import React, {useState, useEffect} from 'react'
import {inject, observer} from 'mobx-react'
import {getMonitorList} from '@apis'
import MonitorItem from '@components/monitorItem'

const RealtimeMonitor = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo

    const [monitorList, setMonitorList] = useState([])
    const [monitor, setMonitor] = useState()
    const [time, setTime] = useState(0)

    async function queryMonitorList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 9999,
      }
      const res = await getMonitorList(params)
      if (res && res.data) {
        setMonitorList(res.data)
        if(res.data[0]) {
          setMonitor({
            monitorAccessToken: res.data[0].monitorAccessToken,
            url: res.data[0].url,
            name: res.data[0].name
          })
        }
      }
    }

    if(time == 0) {
      if(monitorList.length) {
        let timer = null
        clearInterval(timer)
        timer = setInterval(function() {
          for(let i=0; i<monitorList.length; i++) {
            if(monitor && monitorList[i].url == monitor.url) {
              if(i+1 < monitorList.length) {
                setMonitor({
                  monitorAccessToken: monitorList[i+1].monitorAccessToken,
                  url: monitorList[i+1].url,
                  name: monitorList[i+1].name
                })
              } else {
                setMonitor({
                  monitorAccessToken: monitorList[0].monitorAccessToken,
                  url: monitorList[0].url,
                  name: monitorList[0].name
                })
              }
              setTime(1)
            }
          }
        }, 15*1000)
      }
    }

    useEffect(() => {
      queryMonitorList()
    }, [])

    return (
      <div className='ck-monitor'>
        <div className='ck-monitor-title'>安防监控</div>
        <div className='ck-monitor-item'>
          {
            monitorList.length ? (
              <MonitorItem
                url={monitor ? monitor.url : null}
                accessToken={monitor ? monitor.monitorAccessToken : null}
              />
            ) : null
          }
        </div>
        <div className='realtime-name'>{monitor ? monitor.name : null}</div>
      </div>
    )
  })
)

export default RealtimeMonitor